<template>
  <div id="scheduleBox" class="statv_wrapper">
    <h3 class="disabled"> SCHEDULE </h3>
    <div class="schedule_header" v-show="sortedSchedules.length > 0">
      <p class="title"> 
        <span>TODAY'S SPOTV PLUS</span> 
      </p>
      <div class="link_detail"> 
        <p @click="$router.push('/schedule').catch(e => {})">편성표 보기</p>
      </div>
    </div>
    <div class="home_schedule_list-area">
      <div class="swiper_home_schedule">
        <div class="swiper-wrapper">
          <div class="swiper-slide home_schedule_list" v-for="schedule in sortedSchedules" :key="schedule.id">
            <div class="schedule_item" :class="{'now': schedule.now}">
              <div class="schedule_info">
                <div class="schedule_time"> 
                  <p class="cell1"> {{schedule.now ? 'NOW' : isBeforeTime(schedule.time) ? 'NEXT' : 'PREV'}} </p>
                  <p class="cell2"> {{schedule.time}} </p>
                  <p class="cell3 badge" :class="rowClassName(schedule.type)"></p>
                </div>
                <div v-if="isMobile" class="m_next_btn" @click.prevent="next">
                  <p>NEXT</p>
                  <div class="next-img"></div>
                </div>
              </div>
              <p class="schedule_title">{{schedule.content}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev-schedule"></div>
      <div class="swiper-button-next-schedule"></div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import _ from "lodash";
import Utils from "@/helpers/utils.js";
import * as Store from '@/store/modules/schedule';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

export default {
  name: "ScheduleBox",
  data() {
		return {
			searchDate: "",
			isMobile: false,
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 6,
        loop: true,
        speed: 700,
        threshold: 10,
        resizeObserver: false,
        watchOverflow: false,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next-schedule',
          prevEl: '.swiper-button-prev-schedule',
        },
      },
      swiper: null,
		}
	},
	computed: {
		...Store.mapState([
      'schedules'
    ]),
    sortedSchedules() {
      let temp = [];
      let size = _.size(this.schedules);
      let startIndex = _.findIndex(this.schedules, {'now': true});
      //now 없을 경우 return
      if(_.isEqual(startIndex, -1)) return this.schedules;
      //현재 방영중인 데이터 먼저 정렬
      for(let i = startIndex; i < size + startIndex; i++){
        let idx = i >= size ? i - size : i;
        temp.push(this.schedules[idx]);
      }
      return temp;
    }
  },
  created() {
    this.isMobile = Utils.isMobile()
    this.searchDate = moment().format("YYYY-MM-DD");
  },
  async mounted() {
    await this.getSchedules(this.searchDate);
    this.$nextTick(() => {
      this.initSwiper();
    });
  },
  methods: {
    ...Store.mapActions([
      'getSchedules'
    ]),
    async initSwiper() {    
      if (this.isMobile) {
        this.swiperOptions.slidesPerView = 1
      }

      this.swiper = await new Swiper('.swiper_home_schedule', this.swiperOptions);
    },
    rowClassName(type) {
      let list = {   "재방송":  "replay", "생방송":  "live", "본방송":  "air" }
      return _.has(list, type) ? list[type] : ""
    },
    isBeforeTime(time) {
      let now = moment()
      return now.isBefore(moment(time, "HH:mm"), 'HH:mm')
    },
    next() {
      this.swiper.slideNext()
    }
  }
}
</script>
<style lang="less">
#scheduleBox {
  margin: auto;
  .schedule_header {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    letter-spacing: 0;
    margin-bottom: 7px;
    color: #ff6400;
    .title {
      font-size: 36px;
      font-weight: normal;
      > span:first-child {
				font-family: "BebasNeue_Thin";
			}
      > span:last-child {
        font-family: "BebasNeue";
      }
    }
    .link_detail {
      display: flex;
      font-size: 18px;
      font-weight: 400;
      z-index: 1;
      cursor: pointer;
      &::after {
        content: ">";
      }
    }
  }

  .home_schedule_list-area {
    .swiper_home_schedule {
      width: 100%;
      max-width: 1080px;
      overflow: hidden;
  
      .swiper-wrapper {
        .home_schedule_list {
          .schedule_item {
            display: flex;
            flex-direction: column;
            gap: 11px;
            padding: 8px 16px 23px 16px;
            color: #ff6400;
            background-color: #fff3ce;
  
            .schedule_info {
              height: 36px;
              display: flex;
              justify-content: space-between;
              align-items: center;
  
              .schedule_time {
                display: flex;
                align-items: center;
                height: 30px;
                font-family: "BebasNeue";
    
                .cell1 {
                  font-size: 30px;
                  margin-right: 8px;
                }
    
                .cell2 {
                  font-size: 24px;
                  margin-right: 3px;
                }
    
                .badge {
                  width: 20px;
                  height: 20px;
                  margin-bottom: 2px;
                  background-size: contain;
                  background-position: center;
                  background-repeat: no-repeat;
                }
    
                .air { 
                  background-image: url("~@/assets/image/schedule/original-air_img.png");
                }
    
                .replay {
                  background-image: url("~@/assets/image/schedule/re-air_img.png");
                }
    
                .live {
                  background-image: url("~@/assets/image/schedule/live_img.png");
                }
              }
            }
  
            .schedule_title {
              height: 22px;
              font-size: 20px;
              font-weight: 900;
              word-break: break-all;
              text-overflow:ellipsis;
              white-space:nowrap;
              overflow: hidden;
              letter-spacing: 0;
            }
  
            &.now {
              background-color: #ff6400;
              color: #FFFFFF;
  
              .schedule_info {
                .schedule_time {
                  .cell1 {
                    color: #FFFF8C;
                  }
    
                  .air {
                    background-image: url("~@/assets/image/schedule/original-air_img_white.png");
                  }
    
                  .replay {
                    background-image: url("~@/assets/image/schedule/re_badge_now_white.svg");
                  }
    
                  .live {
                    background-image: url("~@/assets/image/schedule/live_badge_now_white.svg");
                  }
                }
              }
            }
          }
        }
      }
    }

    .swiper-button-prev-schedule {
      width: 12px;
      height: 32px;
      position: absolute;
      bottom: 34px;
      left: -32px;
      background-image: url("~@/assets/image/schedule/arrow_left.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      z-index: 1;
      cursor: pointer;
    }
  
    .swiper-button-next-schedule {
      width: 12px;
      height: 32px;
      position: absolute;
      bottom: 34px;
      right: -32px;
      background-image: url("~@/assets/image/schedule/arrow_right.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      z-index: 1;
      cursor: pointer;
    }
  }
}

.m #scheduleBox {
	.schedule_header {
		margin-bottom: 15px;
		.title {
			font-size: 50px;
		}
		.link_detail {
			display: none;
		}
	}

  .home_schedule_list-area {
    .swiper_home_schedule {
      .swiper-wrapper {
        .home_schedule_list {
          .schedule_item {
            gap: 8px;
            padding: 13px 20px 18px 20px;
  
            .schedule_info {
              height: 57px;
              display: flex;
              justify-content: space-between;
              align-items: center;
  
              .schedule_time {
                display: flex;
                align-items: center;
                height: 30px;
                font-family: "BebasNeue";
    
                .cell1 {
                  font-size: 44px;
                  margin-right: 10px;
                }
    
                .cell2 {
                  font-size: 36px;
                }
    
                .badge {
                  width: 25px;
                  height: 25px;
                }
              }

              .m_next_btn {
                display: flex;
                align-items: center;
                gap: 8px;
                position: absolute;
                right: 10px;
                font-family: 'BebasNeue';
                font-size: 44px;
                color: #ff6400;

                .next-img {
                  width: 15px;
                  height: 16px;
                  background-image: url("~@/assets/image/home/arrow_next_m.png");;
                  background-size: contain;
                  background-position: center;
                  background-repeat: no-repeat;
                }
              }
            }
  
            .schedule_title {
              height: 34px;
              font-size: 30px;
            }

            &.now {
              .m_next_btn {
                color: #FFFFFF;

                .next-img {
                  background-image: url("~@/assets/image/home/arrow_next_white_m@2x.png");;
                }
              }
            }
          }
        }
      }
    }

    .swiper-button-prev-schedule,
    .swiper-button-next-schedule {
      display: none;
    }
  }
}
</style>